export default {
  datePicker_shortcuts() {
    return [
      {
        text: '今日',
        value() {
          const end = new Date();
          const start = new Date();
          return [start, end];
        },
      },
      {
        text: '昨日',
        value() {
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
          const end = start;
          return [start, end];
        },
      },
      {
        text: '最近一周',
        value() {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
          return [start, end];
        },
      },
      {
        text: '最近一个月',
        value() {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          return [start, end];
        },
      },
      {
        text: '最近三个月',
        value() {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          return [start, end];
        },
      },
      {
        text: '最近半年',
        value() {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
          return [start, end];
        },
      },
      {
        text: '最近一年',
        value() {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
          return [start, end];
        },
      },
    ];
  },
  platformIcon: {
    1: {
      value: 1,
      name: 'android',
      icon: 'icon-android-r',
      disabled: true,
      active: false,
    },
    2: {
      value: 2,
      name: 'ios',
      icon: 'icon-iOS-r',
      disabled: true,
      active: false,
    },
    4: {
      value: 4,
      name: 'windows',
      icon: 'icon-windows-r',
      disabled: true,
      active: false,
    },
    16: {
      value: 16,
      name: 'html5',
      icon: 'icon-html-r',
      disabled: true,
      active: false,
    },
    32: {
      value: 32,
      name: 'weichat',
      icon: 'icon-miniprogram-r',
      disabled: true,
      active: false,
    },
    64: {
      value: 64,
      name: 'quickapp',
      icon: 'icon-kuaiyingyongSDK',
      disabled: true,
      active: false,
    },
  },

  productType: {
    key19: '书籍',
    key0: '游戏',
    key20: '娱乐',
    key10: '社交',
    key17: '购物与电商',
    key11: '生活',
    key16: '工具',
    key21: '效率',
    key22: '天气',
    key23: '体育',
    key24: '音乐',
    key25: '新闻',
    key26: '报刊杂志',
    key27: '参考',
    key28: '导航',
    key29: '财务金融',
    key12: '健康健美',
    key30: '教育',
    key31: '旅游与出行',
    key32: '商业',
    key9: '摄影录像',
    key33: '医疗',
    key13: '动态壁纸',
    key14: '窗口小部件',
    key8: '其他',
    key3: '角色扮演',
    key34: '模拟类',
    key4: '体育游戏',
    key7: '策略游戏',
    key2: '智力游戏',
    key6: '动作游戏',
    key35: '探险游戏',
    key1: '街机游戏',
    key5: '桌面游戏',
    key36: '扑克牌',
    key37: '娱乐场',
    key38: '股子游戏',
    key39: '教育游戏',
    key40: '家庭游戏',
    key18: '儿童游戏',
    key41: '音乐游戏',
    key42: '赛车游戏',
    key43: '小游戏',
    key44: '文字游戏'
  },

  filterType: {
    partner: {
      title: '渠道',
      list: []
    },
    version: {
      title: '版本',
      list: []
    },
    usergroup: {
      title: '用户分群',
      list: [],
    },
  },

  noVersion: ['dashboard', 'gameReport'],
  noPartner: ['channel', 'channelDetail', 'pageAccess'],
  haveUserGroup: ['keepuser', 'purchase', 'funnelChart'],
};
